/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pesticide_IngredientsInputs */

const vi_pesticide_ingredients = /** @type {(inputs: Pesticide_IngredientsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thành phần`)
};

/**

* @param {Pesticide_IngredientsInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pesticide_ingredients = /** @type {((inputs?: Pesticide_IngredientsInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pesticide_IngredientsInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pesticide_ingredients(inputs)
});